export const SESSION_STORAGE_USER_ROLES_KEY = 'userRoles';
export const SESSION_STORAGE_CURRENT_COMPANY_KEY = 'currentCompany';
export const SESSION_STORAGE_REGISTRO_PRODUCTOR_TOKEN_KEY = 'registroProductorToken';
export const SESSION_STORAGE_REGISTRO_PRODUCTOR_IDENTIDAD_KEY =
	'registroProductorIdentidad';
